<template>
  <Modal
    class="cc-modal"
    width="500"
    footer-hide
    v-model="visibility"
    title="实名认证"
  >
    <div class="content" style="position: relative">
      <loading :loading="loading" style="z-index: 11"></loading>
      <div class="section">
        <div class="bj-rows">
          <div class="name">姓名：</div>
          <Input
            class="bj-input-h45 bj-hover-input-F85A36"
            v-model="form.name"
            placeholder="请输入姓名"
            style="width: 250px"
            clearable
          />
        </div>
        <div class="bj-rows">
          <div class="name">证件类型：</div>
          <Select class="bj-select-h45 bj-hover-select-F85A36" v-model="form.cardType" style="width: 250px">
            <Option
              v-for="item in typeList"
              :key="item.value"
              :value="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </div>
        <div class="bj-rows">
          <div class="name">身份证号码：</div>
          <Input
            class="bj-input-h45 bj-hover-input-F85A36"
            v-model="form.confirmIdCardNumber"
            placeholder="请输入身份证号码"
            style="width: 250px"
            clearable
          />
        </div>
        <div class="c-bj-rows">
          <div class="name">身份证正面照：</div>
          <Upload
            v-if="!form.uplodaPath"
            style="width: 250px"
            type="drag"
            :before-upload="handleBeforeUpload"
            :show-upload-list="false"
            action="/"
          >
            <div class="upload-section">
              <Icon type="md-cloud-upload" size="64" />
            </div>
          </Upload>
          <div
            class="icon2"
            :style="{ backgroundImage: 'url(' + form.uplodaPath + ')' }"
            v-else
          >
            <div class="close" @click="delImage">
              <Icon size="28" type="ios-close-circle-outline" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="foot">
      <Button :loading="loading" @click="onConfirm" class="modal-confirm" style="margin-right: 20px">确定</Button>
      <Button @click="onCancel" class="modal-cancel">取消</Button>
    </div>
  </Modal>
</template>
<script>
import { userIdentitySave } from "api/user.js";
import { mapMutations } from "vuex";
import loading from "components/loading.vue";
export default {
  name: "updateCertifiedModal",
  components: {
    loading,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      typeList: [
        {
          value: 0,
          label: "身份证",
        },
        {
          value: 1,
          label: "护照",
        },
      ],
      form: {
        name: "",
        cardType: 0, // 0：身份证 1：护照
        confirmIdCardNumber: "",
        idCardNumber: "",
        file: "",
        uplodaPath: "",
      },
      loading: false,
    };
  },
  computed: {
    visibility: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  methods: {
    ...mapMutations(["MUT_USER_INFO_USERNAME"]),
    onCancel() {
      this.form = this.$options.data().form;
      this.visibility = false;
    },
    async onConfirm() {
      if (!this.form.name) {
        this.$Message.warning("请输入真实姓名！");
        return;
      }
      if (!this.form.confirmIdCardNumber) {
        this.$Message.warning("请输入正确的证件号码！");
        return;
      }
      if (!this.form.file) {
        this.$Message.warning("请上传证件正面图片！");
        return;
      }
      this.loading = true;
      const data = new FormData();
      data.append("file", this.form.file);
      data.append("confirmNumber", this.form.confirmIdCardNumber);
      data.append("cardNum", this.form.confirmIdCardNumber);
      data.append("username", this.form.name);
      data.append("type", this.form.cardType);
      try {
        const res = await userIdentitySave(data);
        this.loading = false;
        if (res.code === 200 && res.result) {
          this.MUT_USER_INFO_USERNAME(this.form.name);
          this.$emit("submit-success", (res) => {
            if (res) {
              this.onCancel();
              this.$Message.success("提交成功,等待审核成功！");
            }
          });
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    // 选择图片后处理
    handleBeforeUpload(file) {
      if (
        file.type !== "image/jpeg" &&
        file.type !== "image/png" &&
        file.type !== "image/jpg"
      ) {
        this.$Message.warning("图片要求上传jpg或者png格式或者jpeg格式");
        return false;
      }
      this.form.file = file;
      this.form.uplodaPath = window.URL.createObjectURL(file);
      return false;
    },
    // 删除图片
    delImage() {
      this.form.uplodaPath = "";
      this.form.file = "";
    },
  },
};
</script>
<style lang="less" scoped>
  .section{
    padding: 30px 0;
  }
  .bj-rows{
    height: 45px;
    line-height: 45px;
    margin-bottom: 10px;
  }
  .name {
    color: #333333;
    font-size: 16px;
    min-width: 140px;
    text-align: right;
  }
  .c-bj-rows{
    display: flex;
    justify-content: center;
  }
  .upload-section{
    min-height: 122px;
    width: 248px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .icon2 {
      position: relative;
      width: 248px;
      height: 122px;
      background-size: cover;
      background-position: center;
      .close {
        position: absolute;
        right: 5px;
        top: 5px;
        cursor: pointer;
        color: #F85A36;
      }
  }
  .foot {
    border-top: 1px solid #dcdee2;
    padding-top: 16px;
    display: flex;
    justify-content: center;
  }
  ::v-deep .ivu-upload-drag:hover{
    border-color: #F85A36;
  }

</style>
